// extracted by mini-css-extract-plugin
export default {"PageHeading":"PageHeading_PageHeading__tzM1g","append-animate":"PageHeading_append-animate__GESQT"};